import { ButtonProps } from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccessibleButton } from './Accessibility';

type NavButtonProps = ButtonProps & {
	title: string;
	route: string;
};

export const NavButton: FunctionComponent<NavButtonProps> = (props) => {
	const navigate = useNavigate();

	const { title, route, ...buttonProps } = props;

	return <AccessibleButton
		variant="contained"
		size="large"
		onClick={() => navigate(route)}
		{...buttonProps}
	>
		{title}
	</AccessibleButton>;
};